// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../Core.Generator/node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".nav__item--container{position:relative}.nav-arrow{position:absolute;right:-5px}@media(min-width:768px){.nav-arrow{left:10px;position:relative}}.right__arrow{transform:rotate(-90deg)}.rotate__arrow{transform:rotate(0deg)}.upward__arrow{transform:rotate(180deg)}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
module.exports = ___CSS_LOADER_EXPORT___;
